var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      attrs: {
        title: "用户列表",
        visible: _vm.dialogFormVisible,
        modal: false,
        "modal-append-to-body": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        },
        close: function($event) {
          return _vm.rewriteClearData()
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "popover", staticStyle: { "flex-direction": "column" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.reqLoading,
                  expression: "reqLoading"
                }
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "name", label: "学生姓名", align: "center" }
              }),
              _c("el-table-column", {
                attrs: { prop: "school", label: "学校", align: "center" }
              }),
              _c("el-table-column", {
                attrs: { prop: "phone", label: "电话", align: "center" }
              }),
              _c("el-table-column", {
                attrs: { prop: "id_card", label: "身份证", align: "center" }
              })
            ],
            1
          ),
          _vm.tableData.length
            ? _c("el-pagination", {
                attrs: {
                  layout: "total, prev, pager, next",
                  "current-page": _vm.paramsData.page,
                  total: _vm.total,
                  "page-size": 10
                },
                on: { "current-change": _vm.getUserList }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", round: "" },
              on: {
                click: function($event) {
                  _vm.dialogFormVisible = false
                }
              }
            },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }